export class PWAUtil {
  public static get isPWA() {
    return window?.matchMedia('(display-mode: standalone)').matches;
  }
}
